import { useMemo } from "react";

// ЛИСТОПАД НА ПЕРВОМ ЭКРАНЕ.
//
// Весной над hero падают лепестки сакуры, осенью — кленовые листья: форму
// и цвет задаёт сезон (data-season на <html>), а не этот компонент.
// Здесь только раскладка: где начинается каждый элемент, сколько летит,
// с какой задержкой и насколько его сносит вбок.
//
// Почему не Canvas. Canvas ради двенадцати падающих точек — это лишний
// requestAnimationFrame, который крутится на КАЖДОМ кадре и жрёт батарею
// телефона, даже когда экран пролистали. Здесь всё двигает композитор
// браузера на GPU: JavaScript после первой отрисовки не выполняется вообще.
//
// Раскладка считается один раз (useMemo с пустой зависимостью) и не
// пересобирается при перерисовках — иначе лепестки прыгали бы на месте
// при каждой смене языка или сезона.

const COUNT = 12;

// Псевдослучайность со стабильным зерном: раскладка выглядит хаотичной, но
// одинакова у всех и не «дёргается» между рендерами.
const spread = (i) => {
  const seed = Math.sin(i * 12.9898) * 43758.5453;
  return seed - Math.floor(seed); // 0…1
};

export default function PetalFall({ className = "" }) {
  const petals = useMemo(
    () =>
      Array.from({ length: COUNT }, (_, i) => {
        const r = spread(i);
        const r2 = spread(i + 100);
        return {
          left: `${(i / COUNT) * 100 + r * 6}%`,
          size: 7 + r2 * 9, // 7–16 px
          duration: 14 + r * 12, // 14–26 с
          delay: -r2 * 20, // отрицательная: к первому кадру уже летят
          drift: `${(r - 0.5) * 220}px`,
          opacity: 0.28 + r2 * 0.3,
        };
      }),
    []
  );

  return (
    <div className={`petal-field ${className}`} aria-hidden="true">
      {petals.map((p, i) => (
        <span
          key={i}
          className="petal"
          style={{
            left: p.left,
            width: `${p.size}px`,
            height: `${p.size}px`,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            "--petal-drift": p.drift,
            "--petal-opacity": p.opacity,
          }}
        />
      ))}
    </div>
  );
}
